import { useMediaMin } from '../../../components/Media';
import { theme } from '../../../styles';

export const ForaBackground = () => {
  const isTablet = useMediaMin(theme.breakpoint.md);
  const isDesktop = useMediaMin(theme.breakpoint.lg);
  return isDesktop ? (
    <svg width="1600" height="1024" viewBox="0 0 1600 1024" xmlns="http://www.w3.org/2000/svg">
      <g fill="none" fillRule="evenodd">
        <path fill="#004C90" d="M0 0h1600v1024H0z" />
        <path
          d="M1053.08 185.17H1600l-.01 178.974c-320.504 98.14-577.546 344.257-693.57 659.847l-138.575.009a1226.284 1226.284 0 0 1 29.055-80.191L0 943.808l.008-134.447C471.425 782.787 861.468 447.55 976.22.011l134.776-.009a1224.226 1224.226 0 0 1-57.914 185.169zm546.914 369.246-.003 143.302c-149.55 67.665-273.607 182.705-353.55 326.273l-147.132.007c98.481-216.149 278.776-386.24 500.685-469.582zm-.004 347.41L1600 1024l-137.906-.003c39.266-47.664 85.807-88.97 137.896-122.172zM980.498 631.158H743.732c-77.707 70.857-164.677 131.367-258.694 179.952h374.687c35.035-63.663 75.391-123.976 120.773-179.952zm-980.496-2.5.002-133.053C299.28 471.797 549.93 272.868 652.06.011L790.856.004C682.287 347.041 372.396 603.432.002 628.658zm1364.89-310.79H990.256c-35.182 63.91-75.687 124.419-121.266 180.592h236.52c77.855-71.153 165.071-131.86 259.384-180.593zM.005 314.468.002 180.897C123.752 164.153 231.682 96.77 302.792.01L457.083.007C368.509 171.62 199.093 293.704.003 314.469z"
          fill="#00396C"
        />
      </g>
    </svg>
  ) : isTablet ? (
    <svg width="768" height="1024" viewBox="0 0 768 1024" xmlns="http://www.w3.org/2000/svg">
      <g fill="none" fillRule="evenodd">
        <path fill="#004C90" d="M0 0h768v1024H0z" />
        <path
          d="M511.08 146.17H768v132.698H448.254c-35.182 63.91-75.687 124.42-121.266 180.593h236.52c62.518-57.136 131.072-107.537 204.49-150.41l-.017 156.173C574.089 598.388 425.599 794.228 350.919 1023.99l-136.973.009a1225.385 1225.385 0 0 1 40.954-119.19H0V772.11h317.725c35.035-63.663 75.391-123.976 120.773-179.952H201.732C139.97 648.478 72.354 698.259 0 740.713l.013-156.368C200.456 446.016 352.109 240.594 423.443.005L559.444.001a1224.853 1224.853 0 0 1-48.363 146.17zm256.913 548.072.006 194.334a773.075 773.075 0 0 0-83.843 135.412l-143.523.01c50.718-126.756 129.017-239.217 227.36-329.756zM.004 354.882l.009-195.16A772.94 772.94 0 0 0 94.24.003L235.675.002c-49.78 136.916-131.359 258.27-235.67 354.88z"
          fill="#00396C"
        />
      </g>
    </svg>
  ) : (
    <svg width="376" height="697" viewBox="0 0 376 697" xmlns="http://www.w3.org/2000/svg">
      <g fill="none" fillRule="evenodd">
        <path fill="#004C90" d="M0 0h375v697H0z" />
        <path
          d="m375.028 131.477-.027 264.585a1192.373 1192.373 0 0 1-48.012 63.4L375 459.46v132.698H201.732A1199.87 1199.87 0 0 1 69.042 697L0 697l.013-112.655c162.842-112.38 293.483-269.043 375.015-452.868zM375 678.107V697h-12.448A1222.792 1222.792 0 0 1 375 678.107zM.005 354.882l.008-195.16A772.94 772.94 0 0 0 94.239.005L235.675.002C185.895 136.918 104.317 258.27.005 354.88z"
          fill="#00396C"
        />
      </g>
    </svg>
  );
};
